<div class="widget-panel-info">
	<h5 class="widget-title">Categories</h5>
</div>
<ul class="list-unstyled category-list px-0">
	<li class="cat-item border-bottom" *ngFor="let list of categories"><a class="d-block" href="javascript:void(0)">{{list}}</a></li>
</ul>
<!-- category-list wrap close -->

